import AgreeItem from './agree-item';
import Checkbox from './checkbox';
import CheckboxItem from './checkbox-item';

Checkbox.CheckboxItem = CheckboxItem;
Checkbox.AgreeItem = AgreeItem;

export default Checkbox;
